import { useEffect } from "react";
import { applyTelegramChrome } from "../lib/telegramWebAppAuth.js";

export default function TelegramWebAppBootstrap({ children }) {
  useEffect(() => {
    applyTelegramChrome();
  }, []);

  return children;
}
